import React, { useRef } from 'react';
import { CustomTileData } from 'features/layout/features/config/types';
import { CustomTileHost } from 'features/layout/tiles/custom-tile-host/CustomTileHost';
import { CustomTileHostRegistry } from 'features/layout/tiles/custom-tile-host/registry';
import { useCustomTileGeometrySync } from 'features/layout/tiles/custom-tile-host/useCustomTileGeometrySync';
import { selectResizing } from 'features/layout/features/contentDimensions/contentDimensionsSlice';
import { useHoverParent } from 'features/layout/useHoverParent';
import { useAppSelector } from 'store/hooks';

// Inline for the same reason as the host: the PiP window only ever sees the stylesheets that
// existed when it opened.
const LAYER_STYLE: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
};

type CustomTileHostLayerProps = {
  tiles: CustomTileData[];
  registry: CustomTileHostRegistry;
};

export const CustomTileHostLayer = ({ tiles, registry }: CustomTileHostLayerProps) => {
  const layerRef = useRef<HTMLDivElement>(null);

  // The hosts sit outside the tile grid, so they answer for their own share of the tiles area:
  // its hover state and the pointer guard that keeps a drag alive over an iframe.
  const hoverParent = useHoverParent('tiles');
  const resizing = useAppSelector(selectResizing);

  useCustomTileGeometrySync(layerRef, registry, resizing);

  return (
    <div ref={layerRef} style={LAYER_STYLE} data-testid="custom-tile-host-layer">
      {tiles.map((tile) => (
        <CustomTileHost key={tile.name} data={tile} registry={registry} hoverParent={hoverParent} />
      ))}
    </div>
  );
};
